import { ErrorHandler, Injectable, OnDestroy } from '@angular/core';

declare const newrelic: any;
const knownErrors = ['Google Maps JavaScript API error'];
export function isKnownError(errorArgs: any[]): boolean {
  const message = errorArgs?.[0];
  if (typeof message !== 'string') return false;

  return knownErrors.some((err) => message.includes(err));
}

@Injectable()
export class GlobalErrorHandler implements ErrorHandler, OnDestroy {
  private originalConsoleError: (message?: any, ...optionalParams: any[]) => void;

  private errorHandler = (event: ErrorEvent) => {
    const errInfo = {
      script: event.filename || 'Unknown script',
      lineno: event.lineno,
      colno: event.colno,
      message: event.message,
      stack: event.error?.stack || 'No stack trace',
    };
    this.logError(event.error, errInfo);
  };

  constructor() {
    window.addEventListener('error', this.errorHandler);

    this.originalConsoleError = console.error;
    console.error = (...args: any[]): void => {
      if (isKnownError(args)) {
        this.logError(args[0], { type: 'Google Maps API Error', details: args });
      }
    };
  }

  handleError(error: any): void {
    this.logError(error);
  }

  ngOnDestroy(): void {
    console.error = this.originalConsoleError;
    window.removeEventListener('error', this.errorHandler);
  }

  private logError(error: any, additionalInfo: Record<string, any> = {}): void {
    if (typeof newrelic !== 'undefined' && newrelic.noticeError && !error?.name.includes('HttpErrorResponse')) {
      newrelic.noticeError(error, additionalInfo);
    } else {
      console.error('Global Error Handler:', { error, ...additionalInfo });
    }
  }
}
